





















































import {Vue, Component, Prop, Watch} from "vue-property-decorator"
import { Client, ClientCreate, ClientService } from "../../services/accounting.service";
import { ApiResponse, HashMap } from "../../services/base.service";
@Component({
    components: {

    }
})
export default class ClientForm extends Vue {
    @Prop()
    public client!: Client;

    private request!: ClientCreate;

    private api!: ClientService;

    private errors: HashMap<string> = {};

    private loading: boolean = false;

    private error: string | null = null;
    private success: string | null = null;

    private editing: boolean = false;

    created() {
        this.api = new ClientService();
        this.request = {
            name: '',
            contactName: '',
            contactEmail: '',
            rate: 140,
            phone: "",
        }
    }

    @Watch('client')
    public clientChanged() {
        console.log(this.client);
        if (this.client !== null) {
            this.request = this.client;
            this.editing = true;
        } else {
            this.editing = false;
            this.request = {
                name: '',
                contactName: '',
                contactEmail: '',
                rate: 140,
                phone: "",
            }
        }
    }

    public async submit() {
        console.log("SUbmitting", this.request);
        this.errors = {};
        this.loading = true;
        let res: ApiResponse<Client, HashMap<string>>;
        if (this.editing) {
            res = await this.api.put(this.client.id, this.request);
        } else {
            res = await this.api.post(this.request);
        }

        console.log(res);

        if (res.success === true) {
            this.$emit('success', res.result);
        } else {
            this.errors = res.error;
        }
        this.loading = false;
    }
}
